import React, { useEffect, useState} from 'react';
import FollowupAdminPresenter from "@presenters/screens/followup-admin-migration.presenter";
import { IFollowupAdminMigration } from "@interfaces/screens/followup-admin.interface";
import { Container, Row, Col, Button} from 'reactstrap';
import { AEAFieldEditor } from '@components/';
import { Enums, Utilities} from "@utils";

interface IAdminMigrationProps{
}

const AdminMigration: React.FC<IAdminMigrationProps> = () => {
    const [year, setYear] = useState<string>(null)
    const [file, setFile] = useState<FileList>(null)
    const [importData, setImportData] = useState<boolean>(null)
    const [exportData, setExportData] = useState<boolean>(null)
    const [fileValue, setFileValue] = useState<string>("")

    const view: IFollowupAdminMigration = {
        state: {
            setImportData,
            setExportData,
            setFileValue,
            setFile,
            setYear
        },
    };
    
    const presenter = new FollowupAdminPresenter(view);
	
    useEffect(() => {
        if(!!presenter.migrationData && presenter.followupData.length && presenter.formMasters && exportData) presenter.initMigration(year)
    }, [presenter.migrationData, presenter.followupData, presenter.formMasters, year, exportData]);

    useEffect(() => {
        if(!!presenter.migrationData && presenter.followupData.length && presenter.formMasters && importData) presenter.initImportMigration(file)
    }, [presenter.migrationData, presenter.followupData, presenter.formMasters, file, importData]);

    const handleClick = (e: any, isImport?: boolean) => {
        let error = false
        if(isImport){
            if(!file){
                presenter.unSetLoading();
                Utilities.notifyError("Seleccione un archivo", "Error")
                error = true;
            }
            if(!error) setImportData(true)
        }else if(!isImport){
            if(year?.length !== 4){
                presenter.unSetLoading();
                Utilities.notifyError("Digite un año válido", "Error")
                error = true;
            }
            if(!error) setExportData(true)
        }
        e.preventDefault();
        if(!error) presenter.initialize()
    }

    const handleChange = (e: any) => {
        e.preventDefault();
        setFileValue(e.target.value)
        setFile(e.target.files)
    }

    return (
        <Container fluid>
            <label>Exportar: </label>
            <Row xs="6" sm="6" md="8" lg="8" xl="8">
                <Col>
                    <AEAFieldEditor
                        id={"migration"}
                        fieldType={Enums.FieldTypes.Text}
                        placeholder="Año a exportar para la plantilla"
                        onValueChanged={(e) => {setYear(e?.toString())}}
                        value={year}
                        defaultValue={year}
                    ></AEAFieldEditor>
                </Col>
                <Col>
                    <Button onClick={(e) => handleClick(e)}>
                        Exportar
                    </Button>
                </Col>
            </Row>
            <br /><br />
            <label>Importar: </label>
            <Row xs="6" sm="6" md="8" lg="8" xl="8">
                <Col>
                    <input 
                        value={fileValue} 
                        type="file"
                        name="upload"
                        id="upload"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                        onChange={(e) => { handleChange(e) }} 
                    />
                </Col>
                <Col>
                    <Button onClick={(e) => handleClick(e, true)}>Importar</Button>
                </Col>
            </Row>
        </Container>
    )
}

export default AdminMigration;